import * as React from 'react';

import {
  Props,
} from 'one-ui';

export interface BoxChartProps extends Props {
  className?:string;
}

export const BoxChart = ({
  className,
  children,
}: BoxChartProps) => (
  <div className={className}>
    {children}
  </div>
);
